import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslate } from 'react-admin';
import { RowMembersCollapse } from '../../components/RowMembersCollapse';
import { apiUrl, httpClient } from '../../utils/httpUtils';
import { generateQueryParams } from '../../utils/queryParams';

export const Results = ({
  section = null,
  teamId,
  userId,
  dateTo,
  dateFrom,
  isSectionsPage = false,
}) => {
  const t = useTranslate();
  const [results, setResults] = useState({});

  useEffect(() => {
    const getReports = async () => {
      try {
        const params = {
          section: section,
          team_id: teamId,
          user_id: userId,
          date_from: dateFrom,
          date_to: dateTo,
        };
        const query = generateQueryParams(params);
        const url =
          `${apiUrl}/metrics/reports/${isSectionsPage ? 'sections' : 'teams'}?` +
          query;
        const res = await httpClient(url);
        if (res.status === 200) {
          const data = await res.json;
          setResults(data?.results || {});
        }
      } catch (error) {
        console.error('Failed to fetch metrics:', error);
      }
    };

    if (dateFrom && dateTo) {
      getReports();
    }
  }, [teamId, section, userId, dateFrom, dateTo]); //eslint-disable-line react-hooks/exhaustive-deps
  if (!results?.length > 0) return null;

  return (
    <Card
      elevation={0}
      sx={{
        background: '#fff',
        color: '#000',
        padding: '24px',
        marginTop: 2,
        marginBottom: '1em',
        minHeight: '400px',
        minWidth: '500px',
      }}
    >
      <Typography fontSize={26} fontWeight="600" sx={{ marginBottom: '26px' }}>
        {t('resources.reports.list.results_title')}
      </Typography>

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: '3%' }} />
              <TableCell sx={{ width: '30%' }}>
                {isSectionsPage
                  ? t('resources.reports.fields.section')
                  : t('resources.reports.fields.team')}
              </TableCell>
              <TableCell sx={{ width: '17%' }}>
                {t('resources.reports.fields.visits')}
              </TableCell>
              <TableCell sx={{ width: '17%' }}>
                {t('resources.reports.fields.notes')}
              </TableCell>
              <TableCell sx={{ width: '17%' }}>
                {t('resources.reports.fields.rfv')}
              </TableCell>
              <TableCell sx={{ width: '17%' }}>
                {t('resources.reports.fields.subscribers')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(results).map(([_key, item], i) => {
              return (
                <RowMembersCollapse
                  key={i}
                  item={item}
                  openDefault={teamId || userId ? true : false}
                  isSectionsPage={isSectionsPage}
                />
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};
